import React from "react"
import "./index.scss"
import DaysDropDown from "../../components/DaysDropDown"
import {useLocation} from "@reach/router"
import Breadcrumb from "../../components/Breadcrumb"
import {navigate} from "@reach/router"
import {UseStores} from "../../hooks/UseStores"
import {observer} from "mobx-react-lite"
import {brandIdToBrand} from "../../utils/utils"

const LowHeaderContainer = () => {
  const {navStore, disStore, gtMapStore} = UseStores()
  const location = useLocation()
  const path = location.pathname
  let breadcrumbData
  let showDropDown = true
  path.includes("locations") && (showDropDown = false)
  const brandName = brandIdToBrand(navStore.brandId)

  if (path.includes("discovery")) {
    breadcrumbData = [
      {
        key: "Brands",
        label: "Brands",
        className: "breadcrumb-title",
      },
    ]
  } else {
    breadcrumbData = [
      {
        key: "/brands/discovery",
        label: "Brands",
        className: "breadcrumb-title-link",
      },
      {
        key: "/brands/locations",
        label: brandName,
        className: "breadcrumb-subtitle",
      },
    ]
  }

  const clickNavItem = (item) => {
    disStore.setGeoTimeObj({geo: disStore.geoNonePOI})
    gtMapStore.setMapObj({
      geo: disStore.geoNonePOI,
      brandId: disStore.brandId,
      categoryId: disStore.sicCode,
    })
    navigate(item.key)
  }

  const dropDownItem = showDropDown && <DaysDropDown />
  const containerClass = path.includes("locations")
    ? "locations-lowerheader-container"
    : ""

  return (
    <div id="lowerheader-container" className={containerClass}>
      <Breadcrumb breadcrumbData={breadcrumbData} clickNavItem={clickNavItem} />
      {dropDownItem}
    </div>
  )
}
export default observer(LowHeaderContainer)
